import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Bayar Invoices"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Data semua kegiatan finance di PT TKI")
  ])
], -1)
const _hoisted_2 = { class: "card-body py-3" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "No Order"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama Tagihan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Note"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Jumlah Tagihan")
  ])
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Total Tagihan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" })
  ])
], -1)
const _hoisted_16 = { class: "row mt-5 mb-5" }
const _hoisted_17 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Konfirmasi ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          (_ctx.posts.length)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                _createElementVNode("template", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.item.schoolName), 1),
                    _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.item.title), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.item.sourceNumber), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.item.paymentStatus), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.item.note), 1)
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_12, _hoisted_14)),
          _hoisted_15
        ])
      ]),
      _createElementVNode("span", null, "Data =" + _toDisplayString(_ctx.posts), 1),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            type: "submit",
            id: "kt_account_profile_details_submit",
            ref: "submitButton",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveChanges1()))
          }, _hoisted_20, 512)
        ])
      ])
    ])
  ], 2))
}